import type { FC } from 'react';

export const BlitzIcon: FC<{
  color?: string;
}> = (props) => (
  <svg width="100%" height="100%" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M5.41648 1.25L2.11189 5.28892C1.96957 5.46288 1.89842 5.54983 1.89777 5.62317C1.89721 5.68692 1.92589 5.74746 1.9756 5.78737C2.03276 5.83333 2.14513 5.83333 2.36988 5.83333H4.99981L4.58315 8.75L7.88769 4.71108C8.03002 4.53712 8.10119 4.45017 8.10181 4.37683C8.1024 4.31308 8.07373 4.25254 8.02402 4.21262C7.96685 4.16667 7.85448 4.16667 7.62973 4.16667H4.99981L5.41648 1.25Z"
      stroke={props.color || '#E6E6E9'}
      stroke-width="0.833333"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
